// test1597
(1597 && 0);
